<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow relative ms-3 me-3 pt-3">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Stripe Plan</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'stripePlanId' || editMode" :for="field.name">{{ field.label }}:</label>
              <select v-if="field.name === 'planId'" v-model="editedConfig[field.name]" :id="field.name" class="form-select" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }">
                <option v-for="plan in PlansList" :value="plan.planId" :key="plan.planId">{{ plan.planName }} - {{plan.planId}}</option>
              </select>
              <select v-if="field.name === 'stripeConfigurationId'" v-model="editedConfig[field.name]" :id="field.name" class="form-select" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }">
                <option v-for="stripeConfig in StripeConfigList" :value="stripeConfig.stripeConfigurationId" :key="stripeConfig.stripeConfigurationId">{{ stripeConfig.stripeName }} - {{stripeConfig.stripeConfigurationId}}</option>
              </select>
              <input v-if="((field.name !== 'stripePlanId') || (field.name === 'stripePlanId' && editMode)) && (field.name !== 'planId') && (field.name !== 'stripeConfigurationId')"
                  :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                  type="text" class="form-control" :disabled="(field.name === 'stripePlanId') && editMode">
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Stripe Plan' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {StripePlan} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'StripePlanEdit',
  components: {
    Header,
  },
  data () {
    return {
      PlansList: [],
      StripeConfigList: [],
      PlansIds: [],
      editedConfig: {
        stripePlanId : this.$route.params.stripePlanId,
        stripeConfigurationId : this.$route.params.stripeConfigurationId ,
        planId : this.$route.params.planId,
        stripeProductId : this.$route.params.stripeProductId,
        stripePriceId : this.$route.params.stripePriceId,
      },
      editMode: false,
      fields: [
        { name: "stripePlanId", label: "stripePlanId" },
        { name: "stripeConfigurationId", label: "stripeConfigurationId" },
        { name: "planId", label: "planId" },
        { name: "stripeProductId", label: "stripeProductId" },
        { name: "stripePriceId", label: "stripePriceId" },
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.planId) {
      this.editMode = true;
    }
    this.doLoadPlans()
  },
  methods: {
    saveChanges() {
      const dataToSave = new StripePlan(
          this.editedConfig.stripePlanId ,
          this.editedConfig.stripeConfigurationId,
          this.editedConfig.planId ,
          this.editedConfig.stripeProductId ,
          this.editedConfig.stripePriceId ,
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateStripePlan(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'StripePlans' });
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertStripePlan(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'StripePlans' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    },
    doLoadPlans() {
      AdminService.getPlansList().then((data) => {
        this.PlansList = data;
        this.doLoadStripeConfigs();
      }).catch((error) => {
        this.error = error.message
      });
    },
    doLoadStripeConfigs() {
      AdminService.getStripeConfigurationList().then((data) => {
        this.StripeConfigList = data;
      }).catch((error) => {
        this.error = error.message
      });
    }
  }
})
</script>
<style src="../../assets/style.css">
</style>
